var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h4", { staticClass: "mt-1" }, [
        _vm._v("\n        " + _vm._s(_vm.recoveryDetails.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "ol",
        { staticClass: "mb-1 text-mw" },
        _vm._l(_vm.recoveryDetails.stepList, function (step, index) {
          return _c("li", { key: "step-online-" + index }, [
            _vm._v("\n            " + _vm._s(step) + "\n        "),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.recoveryDetails.documentLabel && _vm.recoveryDetails.documentList
        ? [
            _c("p", { staticClass: "mb-0" }, [
              _c("strong", [_vm._v(_vm._s(_vm.recoveryDetails.documentLabel))]),
            ]),
            _vm._v(" "),
            _vm.isDocumentListObject
              ? [
                  _c(
                    "ul",
                    {
                      staticClass: "list mb-0",
                      attrs: { id: "online-details" },
                    },
                    _vm._l(
                      _vm.recoveryDetails.documentList.texts,
                      function (text, index) {
                        return _c(
                          "li",
                          { key: "doc-" + index, staticClass: "text-mw" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(text) +
                                "\n                "
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]
              : _c("p", {
                  staticClass: "mb-0",
                  attrs: { id: "online-details" },
                  domProps: {
                    innerHTML: _vm._s(_vm.recoveryDetails.documentList),
                  },
                }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.recoveryDetails.mentionList
        ? _vm._l(_vm.recoveryDetails.mentionList, function (mention, index) {
            return _c(
              "p",
              { key: "mention-" + index, staticClass: "text-mw mb-0" },
              [_vm._v("\n            " + _vm._s(mention) + "\n        ")]
            )
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }